import { Api } from "./cacheRpcApi";

export let rootCacheApi = new Api();
